import React, { useState, useEffect, Suspense } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import css from "./solution.module.scss";
import { useTranslation } from "react-i18next";

const solutionList = [
  {
    name: "$singlee_cr1",
    path: "/prodandsolution/solution/retail",
  },
  {
    name: "$singlee_yl1",
    path: "/prodandsolution/solution/medical",
  },
  {
    name: "$singlee_sc1",
    path: "/prodandsolution/solution/school",
  },
  {
    name: "$singlee_pk1",
    path: "/prodandsolution/solution/park",
  },
];

function Index() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className={css.contain}>
      <div className={css.topbar}>
        {solutionList.map((item, idx) => {
          return (
            <div
              className={`${css.item} ${
                location.pathname === item.path ? css.active : ""
              }`}
              key={idx}
              onClick={() => navigate(item.path)}
            >
              {t(item.name)}
            </div>
          );
        })}
      </div>
      <div className={css.content} style={{ overflow: "hidden" }}>
        {/* <Suspense fallback={<div>Loading...</div>}> */}
        <Outlet />
        {/* </Suspense> */}
      </div>
    </div>
  );
}

export default React.memo(Index);
